import React from 'react';
import { Link } from 'react-router-dom';
import styles from './StudyRow.module.css';

function badgeFor(status) {
  if (status === 'signed')    return { label: 'SIGNED',    cls: styles.badgeSigned };
  if (status === 'generated') return { label: 'PRELIM',    cls: styles.badgePrelim };
  return { label: '—', cls: styles.badgeNone };
}

function fmt(v) { return v == null || v === '' ? '—' : String(v); }

export default function StudyRow({ study }) {
  const b = badgeFor(study.ai_read_status);
  return (
    <div className={styles.row}>
      <div className={styles.c1}>{fmt(study.study_date)}</div>
      <div className={styles.c2}>{fmt(study.patient_name)}</div>
      <div className={styles.c3}>
        {study.patient_id
          ? <Link to={`/patient/${encodeURIComponent(study.patient_id)}`} className={styles.mrnLink}>{study.patient_id}</Link>
          : '—'}
      </div>
      <div className={styles.c4}>{fmt(study.modality)}</div>
      <div className={styles.c5}>{fmt(study.location_name)}</div>
      <div className={styles.c6}>{fmt(study.study_description)}</div>
      <div className={styles.c7}>{fmt(study.num_images)}</div>
      <div className={styles.c8}><span className={`${styles.badge} ${b.cls}`}>{b.label}</span></div>
      <div className={styles.c9}>
        <Link to={`/study/${encodeURIComponent(study.study_instance_uid)}`} className={styles.open}>Open</Link>
      </div>
    </div>
  );
}
